<template>
  <div class="RMPE-Layout RMPE-Layout-MediaMiddle">
    <div class="columns">
      <div class="column RMPE-Layout-Field">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
import LayoutMixin from '../mixins/layout-mixin';

export default {
  mixins: [LayoutMixin],

  props: {},

  data() {
    return {};
  },

  computed: {},

  methods: {},
};
</script>

<style scoped lang="scss">
.RMPE-Layout-MediaMiddle {

}
.RMPE-Layout-Field {

}
</style>
